import { ITab } from './TabBar';

export const TABS_GAP = 24;

export const NAVIGATION_MENU = 'Navigation menu';
export const MENU_STYLING = 'Menu Styling';
export const TABLE_OF_CONTENTS = 'Table of contents';
export const FOOTER = 'Footer';

export const NavigationMenuTab: ITab = { path: '', name: NAVIGATION_MENU };
export const MenuStylingTab: ITab = { path: 'menu-styling', name: MENU_STYLING };
export const TableOfContentsTab: ITab = { path: 'toc', name: TABLE_OF_CONTENTS };
export const FooterTab: ITab = { path: 'footer', name: FOOTER };
export const TABS_PUBLICATION = [NavigationMenuTab, MenuStylingTab, TableOfContentsTab, FooterTab];

export const PAGE_LAYOUT = 'Page Layout';
export const PROPOSAL_CONTENT = 'Proposal Content';

export const PageLayoutTab: ITab = { path: 'page-layout', name: PAGE_LAYOUT };
export const ProposalContentTab: ITab = { path: 'proposal-content', name: PROPOSAL_CONTENT };
export const TABS_STORIES_LAYOUT = [PageLayoutTab, ProposalContentTab];

export const getNavigationItemProps = ({ name, path }: ITab, activeItem: ITab) => ({
  isActive: name === activeItem?.name,
  path: path,
  name
});
